import {createActions} from '../../framework';

export default createActions(null, ['CLOSE_MOBILE_MENU', 'OPEN_MOBILE_MENU']);
